import React, { useState } from "react";

import Navbar from "../components/Navbar";
import BookingFooter from "../components/BookingFooter";

const FONT_IMPORT_URL = "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&family=Inter:wght@400;500&family=JetBrains+Mono:wght@400;500&display=swap";

const IMAGES = {
  hero: "/assets/hero.png",
  about: "/assets/about-img.png",
  suite1: "/assets/executive/03.png",
  suite2: "/assets/studio/17.png",
  suite3: "/assets/premium/25.png",
  break: "/assets/premium/25.png",
};

const isMobile = window.innerWidth < 768;

const suites = [
  {
    id: "executive",
    name: "Executive Studio",
    image: IMAGES.suite1,
    Suite: "1 BHK",
    level: "Ideal for business travellers",
    bed: "1 Queen Bed",
    size: "400 sq ft",
    price: "₹2,499",
    complimentary: [
      "Wi-Fi",
      "Breakfast",
      "Daily Housekeeping",
      "Parking",
      "Kitchenette Access",
    ],
    tag: "Workspace • Kitchenette • Wi-Fi",
    copy:
      "Thoughtfully designed for professionals and short stays with a dedicated workspace, smart TV, high-speed Wi-Fi and a fully equipped kitchenette.",
  },
  {
    id: "studio",
    name: "Studio Suite",
    image: IMAGES.suite2,
    Suite: "1 BHK",
    level: "Comfort & Space",
    bed: "1 King Bed",
    size: "420 sq ft",
    price: "₹4,499",
    complimentary: [
      "Wi-Fi",
      "Daily Housekeeping",
      "Parking",
      "Kitchenette Access",
    ],
    tag: "Living Area • Kitchenette",
    copy:
      "A spacious suite offering a separate seating area, modern interiors and everything required for both business and leisure stays.",
  },
  {
    id: "premium",
    name: "Premium Suite",
    image: IMAGES.suite3,
    Suite: "2 BHK",
    level: "Comfort & Space",
    bed: "2 King Bed",
    size: "1500 sq ft",
    price: "₹5,499",
    complimentary: [
      "Wi-Fi",
      "Breakfast",
      "Daily Housekeeping",
      "Parking",
      "Kitchenette Access",
    ],
    tag: "Living Area • Kitchenette • Entrance Hall",
    copy:
      "A spacious suite offering a separate seating area, modern interiors and everything required for both business and leisure stays.",
  },
];

const amenities = [
  { title: "24×7 Front Desk", note: "Always available" },
  { title: "High-Speed Wi-Fi", note: "Complimentary" },
  { title: "Daily Housekeeping", note: "Included" },
  { title: "Free Parking", note: "Subject to availability" },
];

function Hero() {
  return (
    <section
      style={{
        minHeight: "100vh",
        backgroundImage: `
          linear-gradient(
            rgba(15,27,38,.55),
            rgba(15,27,38,.70)
          ),
          url(${IMAGES.hero})
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "#F5F2EB",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "140px 48px 48px", // top right/left bottom
      }}
    >
        
      <div style={{ maxWidth: 900 }}>
        <p style={{
          color:"#C9A66B",
          letterSpacing:"0.18em",
          fontFamily:"'JetBrains Mono', monospace"
        }}>
          KOTHANUR • BENGALURU
        </p>

        <h1 style={{
          fontFamily:"'Fraunces', serif",
          fontSize:"clamp(54px,8vw,92px)",
          margin:"12px 0"
        }}>
          Ebenezer
          <br/>
          Serviced Apartments
          <br/>
          & Suites
        </h1>

        <p style={{
          maxWidth:650,
          color:"#CFC9BD",
          fontSize:20,
          lineHeight:1.7
        }}>
          A refined serviced stay designed for business travellers,
          families and extended stays in the heart of Bengaluru.
        </p>

        <a
          href="#rooms"
          style={{
            display:"inline-block",
            marginTop:32,
            background:"#C9A66B",
            color:"#171717",
            padding:"15px 32px",
            textDecoration:"none",
            fontWeight:600
          }}
        >
          Explore Suites
        </a>
      </div>
    </section>
  );
}

function About() {
  return (
    <section style={{padding:"30px 30px",background:"#F5F2EB"}}>
      <div>
        <p
          style={{
            letterSpacing: "0.15em",
            color: "#9B8A73",
            fontFamily: "'JetBrains Mono', monospace",
            marginBottom: 16,
          }}
        >
          ABOUT US
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: 42,
            color: "#222",
            marginBottom: 24,
          }}
        >
          Feel at home while you're away.
        </h2>

        <div
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-6px)";
            e.currentTarget.style.boxShadow = "0 30px 70px rgba(0,0,0,.12)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 20px 60px rgba(0,0,0,.08)";
          }}

          style={{
            maxWidth: 1250,
            margin: "0 auto 40px",
            padding: 16,
            background: "#FFF",
            border: "1px solid rgba(201,166,107,.35)",
            position: "relative",
            transition: "all .4s ease",
            boxShadow: "0 20px 60px rgba(0,0,0,.08)",
            borderTop: "1px solid rgba(201,166,107,.15)"
          }}
        >
          {/* Corner Accent */}
          <div
            style={{
              position: "absolute",
              top: -8,
              left: -8,
              width: 80,
              height: 80,
              borderTop: "3px solid #C9A66B",
              borderLeft: "3px solid #C9A66B",
            }}
          />

          <div
            style={{
              position: "absolute",
              bottom: -8,
              right: -8,
              width: 80,
              height: 80,
              borderBottom: "3px solid #C9A66B",
              borderRight: "3px solid #C9A66B",
            }}
          />

          <img
            src={IMAGES.about}
            alt="Ebenezer Serviced Apartments"
            loading="lazy"
            style={{
              width: "100%",
              height: isMobile ? "auto" : 500,
              objectFit: isMobile ? "cover" : "contain",
              display: "block",
            }}
          />
        </div>   
                     
        <p
          style={{
            width: "min(90%, 800px)",
            margin: "0 auto",
            lineHeight: 1.8,
            color: "#555",
            fontSize: 18,
            textAlign: "center",
          }}
        >
          Located in Kothanur, on the Hennur-Bagalur Rd, <b style={{color: "#FFD700"}}>Ebenezer Serviced Apartments & Suites</b> combines
          the comfort of fully furnished apartments with the convenience of
          premium hospitality. Whether you're visiting Bengaluru for business,
          relocation, medical travel or a family holiday, every stay is designed
          to be effortless.
        </p>
      </div>
    </section>
  );
}

// ---- Continue with Part 2 ----


function Row({ label, value, last }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 0",
        borderBottom: last ? "none" : "1px solid #E7E2D9",
      }}
    >
      <span style={{ color: "#8A8172", fontSize: 14 }}>{label}</span>
      <span
        style={{
          fontFamily: "'JetBrains Mono', monospace",
          color: "#222",
          fontSize: 13,
        }}
      >
        {value}
      </span>
    </div>
  );
}

function SuiteCard({ room, index }) {
  const [open, setOpen] = useState(false);
  const reverse = index % 2 === 1;  

  return (
    <div
        style={{
        padding: "60px 0",
        borderTop: "1px solid #DDD7CC",
        }}
    >
        {/* Top Row */}
        <div
        style={{
            display: "flex",
            flexDirection: "row",            
            alignItems: "center",
            gap: 48,
            flexWrap: "wrap",
        }}
        >
        {/* Image */}
        <div
            style={{
            flex: "1 1 420px",
            order: reverse ? 2 : 1,
            }}
        >
            <img
            src={room.image}
            alt={room.name}
            loading="lazy"
            style={{
                width: "100%",
                height: 320,
                objectFit: "cover",
                border: "1px solid rgba(0,0,0,.08)",
                display: "block",
            }}
            />
        </div>

        {/* Text */}
        <div
            style={{
            flex: "1 1 420px",
            order: reverse ? 1 : 2,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            }}
        >
            <p
            style={{
                color: "#C9A66B",
                fontFamily: "'JetBrains Mono', monospace",
                letterSpacing: ".12em",
            }}
            >
            {room.level.toUpperCase()}
            </p>

            <h2
            style={{
                fontFamily: "'Fraunces', serif",
                fontSize: 40,
                margin: "10px 0",
                color: "#222",
            }}
            >
            {room.name}
            </h2>

            <p
            style={{
                color: "#8A8172",
                fontStyle: "italic",
            }}
            >
            {room.tag}
            </p>

            <p
            style={{
                color: "#555",
                lineHeight: 1.8,
                fontSize: 17,
                maxWidth: 520,
            }}
            >
            {room.copy}
            </p>
        </div>
        </div>

        {/* Booking Card */}
        <div
        style={{
            marginTop: 40,
            maxWidth: 1100,
            marginLeft: "auto",
            marginRight: "auto",
        }}
        >
        <div
            style={{
            background: "#FFF",
            border: "1px solid #DDD7CC",
            padding: 30,
            }}
        >
            <Row label="Bed" value={room.bed} />
            <Row label="Suite" value={room.Suite} />
            <Row label="Size" value={room.size} />
            <Row
              label="Rate"
              value={<strong>{room.price}</strong>}
            />

            <Row
              label="Complimentary"
              value={
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    textAlign: "right",
                  }}
                >
                  {room.complimentary.map((item) => (
                    <span key={item}>✓ {item}</span>
                  ))}
                </div>
              }
              last
            />

            <button
            onClick={() => setOpen(!open)}
            style={{
                width: "100%",
                marginTop: 24,
                padding: "14px",
                background: open ? "#222" : "#C9A66B",
                color: open ? "#FFF" : "#222",
                border: "none",
                cursor: "pointer",
                fontWeight: 600,
            }}
            >
            {open
                ? "Availability Requested ✓"
                : "Check Availability"}
            </button>
        </div>
        </div>
        <p
          style={{
            marginTop: 20,
            fontSize: 14,
            color: "#777",
            textAlign: "center",
            lineHeight: 1.6,
            fontStyle: "italic",
          }}
        >
          * Additional guest with extra mattress: <strong>₹500 per person</strong>.
          Subject to room occupancy limits.
        </p>
    </div>
    );
}

function Suites() {
  return (
    <section
      id="rooms"
      style={{
        background: "#F5F2EB",
        padding: "40px 32px 90px",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".15em",
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          OUR SUITES
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: 44,
            marginBottom: 30,
            color: "#222",
          }}
        >
          Designed for comfort. Built for longer stays.
        </h2>

        {suites.map((room, i) => (
          <SuiteCard key={room.id} room={room} index={i} />
        ))}
      </div>
    </section>
  );
}

// ---- Continue with Part 3 ----

function Amenities() {
  return (
    <section
      style={{
        background: "#1E1E1E",
        color: "#F5F2EB",
        padding: "90px 32px",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".15em",
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          AMENITIES
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: 42,
            marginBottom: 50,
          }}
        >
          Everything you need for a comfortable stay.
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
            gap: 24,
          }}
        >
          {amenities.map((item) => (
            <div
              key={item.title}
              style={{
                padding: 28,
                border: "1px solid rgba(255,255,255,.12)",
                background: "rgba(255,255,255,.04)",
              }}
            >
              <h3
                style={{
                  fontFamily: "'Fraunces', serif",
                  marginBottom: 10,
                }}
              >
                {item.title}
              </h3>

              <p style={{ color: "#C8C3B8" }}>{item.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Nearby() {
  const places = [
    "Manyata Tech Park",
    "Kammanahalli",
    "Mall Of Asia",
    "Bharatiya City",
    "Sparsh Hospital",
    "Majestic Bus Stand",
    "Kristu Jayanti College",
    "New Horizon School",
  ];

  return (
    <section
      style={{
        background: "#F5F2EB",
        padding: "90px 32px",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".15em",
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          LOCATION
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: 42,
            color: "#222",
            marginBottom: 40,
          }}
        >
          Close to Bengaluru's business district.
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
            gap: 18,
          }}
        >
          {places.map((place) => (
            <div
              key={place}
              style={{
                padding: 22,
                background: "#FFF",
                border: "1px solid #DDD7CC",
                fontWeight: 500,
              }}
            >
              {place}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function WhyChooseUs() {
  const features = [
    {
      title: "Business Friendly",
      text: "High-speed Wi-Fi, dedicated workspaces and a peaceful environment.",
    },
    {
      title: "Fully Furnished",
      text: "Kitchenettes, spacious interiors and everything required for longer stays.",
    },
    {
      title: "Prime Whitefield Location",
      text: "Minutes from IT parks, hospitals, shopping and metro connectivity.",
    },
  ];

  return (
    <section
      style={{
        background: "#FFFFFF",
        padding: "90px 32px",
      }}
    >
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <p
          style={{
            color: "#C9A66B",
            letterSpacing: ".15em",
            fontFamily: "'JetBrains Mono', monospace",
          }}
        >
          WHY STAY WITH US
        </p>

        <h2
          style={{
            fontFamily: "'Fraunces', serif",
            fontSize: 42,
            marginBottom: 50,
            color: "#222",
          }}
        >
          Comfort meets convenience.
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
            gap: 28,
          }}
        >
          {features.map((feature) => (
            <div
              key={feature.title}
              style={{
                padding: 30,
                border: "1px solid #E6DFD3",
              }}
            >
              <h3
                style={{
                  fontFamily: "'Fraunces', serif",
                  marginBottom: 12,
                  color: "#222",
                }}
              >
                {feature.title}
              </h3>

              <p
                style={{
                  color: "#666",
                  lineHeight: 1.8,
                }}
              >
                {feature.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function App() {
  return (
    <div style={{ background: "#F5F2EB" }}>
      <style>{`@import url('${FONT_IMPORT_URL}');`}</style>

      <Navbar />
      <Hero />
      <About />
      <Suites />
      <Amenities />
      <Nearby />
      <WhyChooseUs />
      <BookingFooter />
    </div>
  );
}
